<template>
  <div class="status">
    <div class="status__ring" :class="{ 'status__ring--done': getIsFinishedStatus }">
      <svg class="status__ring-track" viewBox="0 0 100 100" aria-hidden="true">
        <circle cx="50" cy="50" r="44" />
      </svg>
      <svg
        v-if="!getIsFinishedStatus"
        class="status__ring-arc"
        viewBox="0 0 100 100"
        aria-hidden="true"
      >
        <circle cx="50" cy="50" r="44" />
      </svg>
      <svg
        v-else
        class="status__ring-full"
        viewBox="0 0 100 100"
        aria-hidden="true"
      >
        <circle cx="50" cy="50" r="44" />
      </svg>

      <span class="status__ring-icon">
        <!-- klucz (w trakcie) - solid, wycentrowany -->
        <svg v-if="!getIsFinishedStatus" viewBox="0 0 24 24" class="icon icon--solid">
          <path
            d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"
          />
        </svg>
        <!-- check (gotowe) -->
        <svg v-else viewBox="0 0 24 24" class="icon">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </span>
    </div>

    <span class="status__label">Status naprawy</span>
    <h2
      class="status__value"
      :class="{ 'status__value--done': getIsFinishedStatus }"
    >
      {{ getStatus }}
    </h2>

    <ol class="steps">
      <li
        v-for="(step, i) in steps"
        :key="i"
        class="steps__item"
        :class="`steps__item--${step.state}`"
      >
        <span class="steps__dot">
          <svg
            v-if="step.state === 'done'"
            viewBox="0 0 24 24"
            class="steps__check"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </span>
        <span class="steps__label">{{ step.label }}</span>
      </li>
    </ol>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DetailsStatus",
  computed: {
    ...mapGetters(["getStatus", "getIsFinishedStatus"]),
    steps() {
      const finished = this.getIsFinishedStatus;
      return [
        { label: "Przyjęto", state: "done" },
        { label: "W naprawie", state: finished ? "done" : "active" },
        { label: "Gotowe", state: finished ? "done" : "pending" },
      ];
    },
  },
};
</script>
